export const NCCC_LOGO =
  "https://customer-assets.emergentagent.com/job_void-hexagon-1/artifacts/m8pm8dpf_8A888CA7-6DDF-4963-AC2B-7D1DAA2540E3.PNG";

export const HERO_IMAGE =
  "https://images.pexels.com/photos/6954359/pexels-photo-6954359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const RELEASES_PLACEHOLDER =
  "https://images.pexels.com/photos/10985335/pexels-photo-10985335.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const PORTALS_PLACEHOLDER =
  "https://images.unsplash.com/photo-1571846052945-f70f6b2542d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwYnJvYWRjYXN0JTIwZXF1aXBtZW50fGVufDB8fHx8MTc4MjI3NDE1Mnww&ixlib=rb-4.1.0&q=85";

export const AFFILIATES_PLACEHOLDER =
  "https://images.unsplash.com/photo-1644365978029-d14ed81d8aa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxhbmFsb2d1ZSUyMG1hZ25ldGljJTIwdGFwZXxlbnwwfHx8fDE3ODIyNzQxNTJ8MA&ixlib=rb-4.1.0&q=85";
